import { UseMutateFunction } from '@tanstack/react-query';
import { useForm, SubmitHandler } from 'react-hook-form';

import useTranslation from 'customHooks/translate';
import { ResetPasswordFormSubuserInputs } from 'types';

import { Input } from '../common/input';
import { Button } from 'antd';

interface IProps {
  passwordResetHandler: UseMutateFunction<any, unknown, any>;
  token: string;
  isLoading: boolean;
}

const ResetPasswordFormSubuser = ({
  passwordResetHandler,
  token,
  isLoading,
}: IProps) => {
  const { register, handleSubmit, watch, formState } =
    useForm<ResetPasswordFormSubuserInputs>();
  const translation = useTranslation();

  const { errors } = formState;

  let pwd = watch('password');

  const onSubmit: SubmitHandler<ResetPasswordFormSubuserInputs> = (data) =>
    passwordResetHandler({
      password: data.password,
      confirmPassword: data.confirmPassword,
      token,
    });

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-[24px]"
      >
        <div className="flex flex-col gap-[8px]">
          <Input
            id="password"
            label="Set new password"
            placeholder="• • • • • • • •"
            error={errors.password}
            type="password"
            autoComplete="current-password"
            {...register('password', {
              required: translation.passwordRequired,
            })}
          />
        </div>
        <div className="flex flex-col gap-[8px]">
          <Input
            id="password-repeat"
            label="Repeat password"
            placeholder="• • • • • • • •"
            error={errors.confirmPassword}
            type="password"
            {...register('confirmPassword', {
              validate: (value) =>
                value === pwd || translation.passwordNotMatch,
            })}
          />
        </div>
        <input type="hidden" value={token} {...register('token')} />
        <Button
          htmlType="submit"
          className="h-[44px] rounded-md !border-0 !bg-[#6DCE92] font-medium !text-white shadow-none transition-colors duration-200 hover:!border-0 hover:!bg-[#5EC082] hover:!text-white focus:!border-0 focus:!bg-[#6DCE92] focus:!text-white active:!border-0 active:!bg-[#5EC082] active:!text-white"
          loading={isLoading}
        >
          Set Password
        </Button>
      </form>
    </>
  );
};

export default ResetPasswordFormSubuser;
